import { useContext } from "react";
import { isEliteOrPremiumTier } from "./eliteOrPremiumTier";
import { UserContext } from "@/App";

/**
 * Whether the signed-in user is Elite or Premium. See `isEliteOrPremiumTier`.
 */
export const useIsEliteOrPremium = (): boolean => {
  const { sessionInfo } = useContext(UserContext);
  return isEliteOrPremiumTier(sessionInfo);
};
